import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CompanyApiService } from 'src/app/services/api/company-api.service';
import { LeadApiService } from 'src/app/services/api/lead-api.service';
import { BasicInfoService } from 'src/app/services/basic-info.service';
import { FlowService } from 'src/app/services/flow.service';
import { LocaleService } from 'src/app/services/locale.service';
import { PersonalInfoService } from 'src/app/services/personal-info.service';
import { TrackingService } from 'src/app/services/tracking.service';
import { BasicInfoScreenComponent } from '../basic-info-screen/basic-info-screen-fi.component';
import { LoginApiService } from 'src/app/services/api/login-api.service';
import { AuthService } from 'src/app/services/auth.service';
import { ApplicationService } from 'src/app/services/application-service';

@Component({
  selector: 'app-big-ticket',
  templateUrl: './big-ticket-fi.component.html',
  styleUrls: ['./big-ticket.component.scss']
})

export class BigTicketComponent extends BasicInfoScreenComponent { 
  constructor(
    protected basicInfoService: BasicInfoService,
    protected formBuilder: FormBuilder,
    protected companyApi: CompanyApiService,
    protected leadApi: LeadApiService,
    protected translateService: TranslateService,
    protected personalInfoService: PersonalInfoService,
    protected loginApi: LoginApiService,
    protected authService: AuthService,
    protected applicationService: ApplicationService,
    protected trackingService: TrackingService,
    protected localeService: LocaleService,
    protected route: ActivatedRoute,
    public flowService: FlowService,
  ) { 
      super(
        basicInfoService,
        formBuilder,
        companyApi,
        leadApi,
        translateService,
        personalInfoService,
        loginApi,
        authService,
        applicationService,
        trackingService,
        localeService,
        route,
        flowService,
      ) 
    }
}
